export function preventScrollPropagation(container: HTMLElement) {
  let lastY = 0;
  const wheelHandler = (e: WheelEvent) => {
    const { scrollTop, scrollHeight, clientHeight } = container;
    const isAtTop = scrollTop === 0;
    const isAtBottom = scrollTop + clientHeight === scrollHeight;
    if ((e.deltaY < 0 && isAtTop) || (e.deltaY > 0 && isAtBottom)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const touchStartHandler = (e: TouchEvent) => {
    lastY = e.touches[0].clientY;
  };
  const touchMoveHandler = (e: TouchEvent) => {
    const currentY = e.touches[0].clientY;
    const deltaY = currentY - lastY;
    lastY = currentY;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const isAtTop = scrollTop === 0;
    const isAtBottom = scrollTop + clientHeight === scrollHeight;
    if ((deltaY > 0 && isAtTop) || (deltaY < 0 && isAtBottom)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  container.addEventListener('wheel', wheelHandler, { passive: false });
  container.addEventListener('touchstart', touchStartHandler, { passive: false });
  container.addEventListener('touchmove', touchMoveHandler, { passive: false });
  return () => {
    container.removeEventListener('wheel', wheelHandler);
    container.removeEventListener('touchstart', touchStartHandler);
    container.removeEventListener('touchmove', touchMoveHandler);
  };
}
